import React from "react";
import "./styles/contactus.css";
import wabes from './styles//images/download.svg';
import about_img3 from './styles/images/about-img3.jpg';
import MapComponent from "./Map";
import TestimonialMarquee from "./testimonialmarquee";
import Footer from "./Footer";
import about_img2 from './styles/images/about-img2.jpg';
import ContactForm from "./contact_form";
import { FaMapMarkerAlt } from "react-icons/fa";

function Contact(){
   
    return (
        <>
        <section id="Contact" className="about">
            <div className="wrap"></div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
                        <h1>
                        Need <strong> <span className="hero-highlight">Assistance?</span></strong><br />  <strong><span className="hero-highlight"> Contact Us!</span></strong>
                        </h1>
                        <p>
                            If you have any questions or need help, please don't hesitate to contact us.
                        </p>
                    </div>
                </div>
            </div>
               <img src={wabes} alt="Waves" id="waves1" />
        </section>
         <section id="Contact-about mt-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12" id="about-column">
                                    <h1>Compassionate Care for Your Loved Ones</h1>
                                    <p>
                                        Caring for your senior loved ones is our top priority. We provide professional, reliable, and personalized home care to ensure they live comfortably and with dignity. Our skilled caregivers are dedicated to meeting their unique health and personal needs, giving you peace of mind. Let us be a trusted part of your family’s journey to a better quality of life. We’re here for you every step of the way!                            </p>
                                    {/* <button className="hero-btn">
                                        Learn More
                                    </button> */}
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-12" id="about-column1">
                                   
                                    <div className="img-hold">
                                        <img src={about_img3} alt="Professional home care services in Minnesota – Sammah Home Care" id="about-img" />
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="Map">            
                                <MapComponent /> 
                    </section>
                    <section id="Ser-cards">
                        <div className="row">
                        <h2 >Get an <span className="hero-highlight">OverView</span></h2>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 pb-5">
                                <TestimonialMarquee />
                                </div>
                            </div>
                        </div>
                        
                    </section>
                    <section id="Form">
    <div className="container">
        <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12" id="Form-img" data-aos="slide-up" >
                            <img src={about_img2} alt="Old man taking care of his wife" className="img-fluid rounded" width={'95%'} />
                            </div>
                        <div className="col-lg-6 col-md-6 col-sm-12" id="form-text">
                            <h1 data-aos="slide-up">
                                Client Intake Form !
                            </h1>
                            <p>
                            At Unique Home Care, we are committed to providing compassionate, client-focused support that empowers individuals to live comfortably and independently in their own homes.
                            </p>
                            <p data-aos="slide-up">
                                <strong> Download </strong> the Client InTake Form below !
                            </p>
                            <button className="nav0cta1" ><a href="#Contactform" style={{textDecoration:'none', color:'white'}} >Client Intake Form </a></button>
                        </div>
        </div>
    </div>
</section>
                    <section id="Contactform">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 pb-3 ">
                                    <h1>Get in <span className="hero-highlight">Touch</span></h1>
                                    <p>We’d Love to Hear from You!</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-1">
                                <ContactForm />
                                </div>
                                
                            </div>
                        </div>
                    </section>
                    <section class="cities-container">
    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Twin Cities</h3>
        <p>We provide top-notch home care services in the Twin Cities, ensuring comfort and quality care for residents.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Willmar</h3>
        <p>Serving the Willmar area with dedicated in-home care, making daily living easier for families and individuals.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Marshall</h3>
        <p>Offering compassionate care services in Marshall, helping residents live independently with dignity.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Worthington</h3>
        <p>Bringing quality health and home care services to Worthington, ensuring well-being and support for all.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Austin</h3>
        <p>Providing expert caregiving services in Austin, Minnesota, with personalized assistance for daily needs.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Albert Lea</h3>
        <p>Ensuring seniors and families in Albert Lea receive the best home care services tailored to their needs.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>St. Cloud</h3>
        <p>Delivering professional home care in St. Cloud, supporting the elderly and those in need of assistance.</p>
    </div>

    <div class="card3">
    <FaMapMarkerAlt className="map-icon" />
        <h3>Benson</h3>
        <p>Compassionate home care services in Benson, focused on enhancing quality of life for residents.</p>
    </div>
</section>
                    <footer>
                        <Footer />
                    </footer>
        </>
    )
}
export default Contact;
